<template>
  <div class="big-container" v-if="equipmentDialog">
    <div class="container">
      <p class="title">登录设备管理</p>
      <span class="descrip">当前账号已有 3 个常用设备，请删除其他设备后登录</span>
      <div class="allCheckbox">
        <span class='fc' @click="deleteEquipment">删除设备</span>
        全选 &nbsp;&nbsp;
        <!--        <input type="checkbox" name="" id="ipt" v-model="judgmentCheckout" :disabled="prepareDelEquipmentFn.length === 3">-->
        <el-checkbox v-model="allChecked" @change="(state) => allCheckedChange(state)" style="margin-left: 6px;" />
      </div>
      <div class="equipment-container">
        <div class="equipment-item" v-for="(item,index) in deviceList" :key="index">
          <div class="equipment-name">

            {{item.device_name}}
            <span class="fntSize" v-if="item.deleted_at">已删除</span>
            <el-checkbox v-model="item.checked" @change="(row) => itemCheckChange(row, item, index)" v-else />
          </div>
          <div class="equipment-number">{{item.updated_at | filDate}}</div>
        </div>
      </div>
      <div class="footer-btn">
        <div class="cancle" @click="cancelFn">取消</div>
        <!--        <div :class="prepareDelEquipmentFn.length !== 0 ? 'immediately-login btn-color' : 'immediately-login'" @click="dialogLogin">立即登录</div>-->
        <el-button type="primary" :disabled="loginState" @click="dialogLogin">立即登录</el-button>
      </div>
    </div>
  </div>
</template>

<script>
	export default{
		name:'',
		props: {
			equipmentDialog: {
				type: Boolean,
				required: true,
				default: false
			},
			equipmentList: {
				type: Array,
				required: true,
				default: () => []
			},
		},
		data () {
			return {
				allChecked: false,
				deviceList: []
			}
		},
		filters: {
			filDate(val) {
				let d = new Date(val)
				let year = d.getFullYear();
				let month = d.getMonth() + 1;
				let day = d.getDate();
				let hours = d.getHours();
				let minutes = d.getMinutes();

				let m_len = month.toString().length;
				if(m_len < 2) {
					month = "0" + month;
				}
				let d_len = day.toString().length;
				if(d_len < 2) {
					day = "0" + day;
				}
				let h_len = hours.toString().length;
				if(h_len < 2) {
					hours = "0" + hours;
				}
				let M_len = minutes.toString().length;
				if(M_len < 2) {
					minutes = "0" + minutes;
				}

				var resStr = year.toString()+ "." + month.toString() + "." + day.toString() + " " + hours.toString() + ":" + minutes.toString();
				return resStr;
			}
		},
		watch: {
			equipmentList: {
				deep: true,
				handler(newVal, oldVal) {
					this.deviceList = newVal.map(item => {
						item.checked = false
						return item
					})
				}
			},
			deviceList: {
				deep: true,
				handler(newVal, oldVal) {
					this.allChecked = newVal.filter(item => item.checked).length === 3
				}
			}
		},
		computed:{
			loginState() {
				return !(this.equipmentList.filter(item => !item.deleted_at).length < 3)
			}
		},
		methods:{
			allCheckedChange(state) {
				this.deviceList = this.deviceList.map(item => {
					item.checked = state
					return item
				})
			},
			itemCheckChange(checked, item, index) {
				this.$set(this.deviceList, index, item)
			},
			cancelFn(){
				this.$emit('cancelFn')
			},
			deleteEquipment() {
				const delList = []
				this.deviceList.forEach(item => {
					if (item.checked) {
						delList.push(item.device_number)
					}
				})
				console.log(delList, "==============>delete")
				if (!delList.length) {
					this.$message.error('请选择你要删除的设备')
					return
				}
				this.$emit('delEquipmentFn', delList)
			},
			dialogLogin() {
				this.$emit('login')
			}
		}
	}
</script>

<style lang="scss" scoped>
  * {
    box-sizing: border-box;
  }
  .big-container {
    position: fixed;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 20;
    width: 100vw;
    height: 100vh;
    background: rgba(0,0,0,0.6);
    input {
      width: 16px;
      height: 16px;
      outline: none; /* 隐藏默认的外边框 */
      border-color: #404040; /* 修改选中时的边框颜色 */
    }
    input:checked {
      font-size: inherit;
      color: #404040;
    }


    /* css 复选框 */
    input[type=checkbox] {
      cursor: pointer;
      position: relative;
    }

    input[type=checkbox]::after {
      position: absolute;
      top: 0;
      background-color: #fff;
      color: #fff;
      width: 16px;
      height: 16px;
      display: inline-block;
      visibility: visible;
      padding-left: 0px;
      text-align: center;
      content: ' ';
      border-radius: 2px;
      box-sizing: border-box;
      border: 1px solid #CFCFCF;
    }

    input[type=checkbox]:checked::after {
      content: "";
      background-color: #404040;
      border-color: #404040;
      background-color: #404040;
    }

    input[type=checkbox]:checked::before {
      content: '';
      position: absolute;
      top: 1px;
      left: 5px;
      width: 3px;
      height: 8px;
      border: solid #CFCFCF;
      border-width: 0 2px 2px 0;
      transform: rotate(45deg);
      z-index: 1;
    }

    .container {
      opacity: 1;
      width: 446px;
      height: 419px;
      padding: 28px 32px 0;
      margin: 0 auto;
      background: #FFFFFF;
      box-shadow: 0px 2px 8px 0px rgba(0,0,0,0.13);
      border-radius: 4px;
      .title {
        font-size: 18px;
        font-weight: 500;
        color: #404040;
        margin-bottom: 12px;
      }
      .descrip {
        display: block;
        font-size: 14px;
        font-weight: 400;
        color: #9C9C9C;
        margin-bottom: 24px;
      }
      .allCheckbox {
        display: flex;
        justify-content: end;
        margin-bottom: 15px;
        font-size: 14px;
        padding-right: 24px;
        span {
          cursor: pointer;
          margin-right: 16px;
        }
        input {
          margin-left: 6px;
        }
        input:checked {
          background-color: red !important;
        }
        .fc {
          cursor: pointer;
          color: #FF4F4C;
        }
      }
      .equipment-container {
        background: #F9F9F9;
        border-radius: 4px;
        padding: 24px;
        height: 194px;
        overflow-y: auto;
        .equipment-item {
          height: 38px;
          margin-bottom: 16px;
          .equipment-name {
            display: flex;
            justify-content: space-between;
            height: 20px;
            margin-bottom: 6px;
            font-size: 14px;
            font-weight: 400;
            color: #404040;
            span {
              cursor: pointer;
              color: #FF4F4C;
            }
            .fntSize {
              color: #9C9C9C;
            }
          }
          .equipment-number {
            height: 12px;
            font-size: 12px;
            font-weight: 400;
            color: #9C9C9C;
          }
        }
        margin-bottom: 28px;
      }
      .footer-btn {
        height: 36px;
        display: flex;
        justify-content: end;
        &>div {
          display: flex;
          width: 102px;
          justify-content: center;
          align-items: center;
          font-size: 14px;
          font-weight: 400;
          border-radius: 2px;
        }
        button{
          padding-top: 0;
          padding-bottom: 0;
        }
        .cancle {
          cursor: pointer;
          color: #606060;
          border: 1px solid #D9D9D9;
          margin-right: 16px;
        }
        .immediately-login {
          cursor: pointer;
          background: #9C9C9C;
          color: #FFFFFF;
        }
        .btn-color {
          background-color: #FF4F4C;
        }

      }
    }
  }

</style>
